import React, { useEffect, useState, useRef } from 'react'
import { StyleProvider } from '@ant-design/cssinjs'
import { Route, Switch, withRouter, Redirect } from 'react-router-dom'
import { message, ConfigProvider, App } from 'antd'
import { ConfigProvider as ConfigProviderMobile, setDefaultConfig } from 'antd-mobile'
import enCN from 'antd-mobile/es/locales/zh-CN'
import enUS from 'antd-mobile/es/locales/en-US'
import { useSelector, useDispatch } from 'react-redux'
import { hasCategoryPermission } from '@/annotations/nike-react'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import zh_CN from 'antd/locale/zh_CN'
import en_US from 'antd/locale/en_US'
import { formatMessage, languageObj } from '@/utils/common'
import { clearAuthentication, getAuthenticationStatus, redirectURL } from '@/utils/authHelp'
import { modalError } from '@/utils/modalUtils'
import { setLanguageObj } from '@/redux/actions/commonActions'

import LoginLayout from '@/pages/layout/LoginLayout'
import MainLayout from '@/pages/layout/MainLayout'
import PhoneLayout from '@/pages/layout/PhoneLayout'
import PhoneTagLogin from '@/pages/AndroidDevice/TagLogin'
// import QrLoginUnBinding from '@/pages/AndroidDevice/login/qrLoginUnBinding'
import NFCGameOn from '@/pages/AndroidDevice/NFCGameOn'
// import store from './redux'
import './App.less'
import 'animate.css'
dayjs.locale('zh-cn')
message.config({
  // top: 10,
  duration: 3,
  maxCount: 1
})
const defaultSize = 13
const defaultHeight = 30
const AppPage = props => {
  let userAgent = navigator.userAgent.toLowerCase()
  let isHasMobile = userAgent.includes('mobile')
  const dispatch = useDispatch()
  const [locale, setLocal] = useState({})
  const [localMobile, setLocalMobile] = useState(enUS)
  const deviceSize = useSelector(state => state.commonStore.deviceSize)
  const commonStore = useSelector(state => state.commonStore)
  const languageState = useSelector(state => state.commonStore.language)
  const tokenInvalidModalShown = useRef(false)
  // store.subscribe(() => {
  //   const state = store.getState()
  //   const language = state.commonStore.language
  //   if (language === 'zh_CN') {
  //     dayjs.locale('zh-cn')
  //     setLocal(zh_CN)
  //   }
  //   if (language === 'en_US') {
  //     dayjs.locale('en')
  //     setLocal(en_US)
  //   }
  // })
  useEffect(() => {
    if (languageState === 'zh_CN') {
      dayjs.locale('zh-cn')
      setLocal(zh_CN)
      if (isHasMobile) {
        // 设置移动端语言
        setLocalMobile(enCN)
        // 设置移动端语言，如Modal
        setDefaultConfig({
          locale: enCN
        })
      }
    }
    if (languageState === 'en_US') {
      dayjs.locale('en')
      setLocal(en_US)
      if (isHasMobile) {
        // 设置移动端语言
        setLocalMobile(enUS)
        // 设置移动端语言，如Modal
        setDefaultConfig({
          locale: enUS
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageState])

  useEffect(() => {
    dispatch(setLanguageObj(languageObj[languageState]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale, localMobile])
  const getTokenInvalidContent = () => {
    const content = formatMessage(commonStore, 'languageObj.httpLocale.tokenInvalid')
    if (content) return content

    const currentLanguageObj = languageObj[languageState] || {}
    const httpLocale = currentLanguageObj.httpLocale || {}
    return httpLocale.tokenInvalid || 'The access token is invalid'
  }
  const handleTokenInvalid = () => {
    if (tokenInvalidModalShown.current) return
    tokenInvalidModalShown.current = true
    modalError(
      {
        content: getTokenInvalidContent()
      },
      () => {
        tokenInvalidModalShown.current = false
        clearAuthentication()
        window.location.href = redirectURL
      }
    )
  }
  const authStatus = getAuthenticationStatus()
  useEffect(() => {
    if (props.location.pathname === '/login' && (authStatus.reason === 'expired' || authStatus.reason === 'invalid')) {
      handleTokenInvalid()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location.pathname, authStatus.reason])
  const selectHtml = () => {
    return (
      <ConfigProvider
        locale={locale}
        theme={{
          token: {
            // paddingXS: 7,
            fontSize: defaultSize * deviceSize,
            controlHeight: defaultHeight * deviceSize
          }
          // components: {
          //   Card: {
          //     bodyPadding: 4
          //   }
          // }
        }}
      >
        <App>
          <Switch>
            <Route
              path="/login"
              render={() => {
                if (authStatus.authenticated) {
                  let path = ''
                  if (isHasMobile) {
                    path = '/'
                  } else {
                    if (hasCategoryPermission('NFC')) {
                      path = '/'
                    } else {
                      path = '/'
                    }
                  }
                  return <Redirect to={path} />
                } else if (authStatus.reason === 'expired' || authStatus.reason === 'invalid') {
                  return null
                } else {
                  return <LoginLayout />
                }
              }}
            />
            {/* <Route path="/qr/unbind/login" component={QrLoginUnBinding} /> */}
            <Route path="/NFC_game_on" component={NFCGameOn} />
            <Route path="/rf/login" component={PhoneTagLogin} />
            <Route path="/" component={isHasMobile ? PhoneLayout : MainLayout} />
          </Switch>
        </App>
      </ConfigProvider>
    )
  }
  return (
    <div id="container">
      {isHasMobile ? (
        <StyleProvider hashPriority="high">
          <ConfigProviderMobile locale={localMobile}>{selectHtml()}</ConfigProviderMobile>
        </StyleProvider>
      ) : (
        selectHtml()
      )}
    </div>
  )
}

export default withRouter(AppPage)
